module.exports = __webpack_public_path__ + "static/media/medicare-5-star-100x100.f123bfc5.png";